export default __webpack_public_path__ + "static/media/nav-groceries-red.dd149c67.svg";